import React, { useEffect } from 'react';
import { Phone, Mail } from 'lucide-react';
import { company, serviceFaqs, constructionFaqs, waterHeaterFaqs, drainFaqs, backflowFaqs, sewerLineFaqs, aboutFaqs, teamFaqs, galleryFaqs, careersFaqs, reviewsFaqs, contactFaqs } from '../mock';
import { FaqAccordion } from '../sections/RestSections';
import Seo from '../components/Seo';
import StructuredData from '../components/StructuredData';

const SECTIONS = [
  { eyebrow: 'Service Plumbing', title: 'Repairs, service calls & everyday plumbing', items: serviceFaqs },
  { eyebrow: 'Water Heaters', title: 'Tank & tankless water heaters', items: waterHeaterFaqs },
  { eyebrow: 'Drains & Clogs', title: 'Drain cleaning & clog removal', items: drainFaqs },
  { eyebrow: 'Sewer & Water Lines', title: 'Sewer & water line service', items: sewerLineFaqs },
  { eyebrow: 'Backflow Prevention', title: 'Backflow testing & certification', items: backflowFaqs },
  { eyebrow: 'Construction & New Builds', title: 'New construction, remodels & repipes', items: constructionFaqs },
  { eyebrow: 'About Us', title: 'About Victory Plumbing', items: aboutFaqs },
  { eyebrow: 'Our Team', title: 'The people behind the work', items: teamFaqs },
  { eyebrow: 'Our Work', title: 'Projects & gallery', items: galleryFaqs },
  { eyebrow: 'Careers', title: 'Working at Victory Plumbing', items: careersFaqs },
  { eyebrow: 'Reviews', title: 'Ratings & reviews', items: reviewsFaqs },
  { eyebrow: 'Contact', title: 'Reaching us & getting started', items: contactFaqs },
];

const ALL_FAQS = SECTIONS.flatMap((s) => s.items);

export default function FaqPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <main className="page faq-page" data-testid="faq-page">
      <Seo title="Frequently Asked Questions" description="Answers about services, water heaters, drains, sewer lines, backflow, new construction, licensing, reviews, careers & contact from Victory Plumbing in Savannah, GA." path="/faq" />
      <StructuredData faqItems={ALL_FAQS} />
      <section className="page-hero">
        <div className="wrap">
          <p className="eyebrow">Common Questions</p>
          <h1>Frequently asked questions</h1>
          <p className="lede">
            Everything you might want to know about Victory Plumbing &mdash; from services, water heaters, and
            drains to new construction, licensing, reviews, and getting in touch. Still not sure? We&rsquo;re happy to help.
          </p>
        </div>
      </section>

      <section className="faq-full">
        <div className="wrap">
          {SECTIONS.map((s, i) => (
            <div key={s.eyebrow} data-testid={`faq-section-${i}`}>
              <div className="sec-head" style={{ margin: i === 0 ? '0 0 24px' : '48px 0 24px' }}>
                <p className="eyebrow">{s.eyebrow}</p>
                <h2>{s.title}</h2>
              </div>
              <FaqAccordion items={s.items} />
            </div>
          ))}

          <div className="faq-contact-card" data-testid="faq-contact-card">
            <div>
              <h3>Still have questions?</h3>
              <p>Give us a call or send a message &mdash; we&rsquo;ll get you a clear answer.</p>
            </div>
            <div className="about-cta" style={{ margin: 0 }}>
              <a className="btn btn-gold" href={company.phoneHref}><Phone size={16} /> {company.phoneDisplay}</a>
              <a className="btn btn-outline-dark" href={`mailto:${company.email}`}><Mail size={16} /> Email Us</a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
